import { COLLECTIBLE_DATA } from "@/util/crypto"
import { createPublicClient, http } from "viem"
import { mainnet } from "viem/chains"

import { unstable_cache } from "next/cache"

const publicClient = createPublicClient({
  chain: mainnet,
  transport: http(COLLECTIBLE_DATA.ethereum.providerUrl),
})

type WalletNameType = "WALLET_ADDRESS" | "ENS"

export type WalletNameAndType = {
  name: string
  type: WalletNameType
}

/**
 * We always want to cache the wallet name.
 */
export const getWalletName = unstable_cache(
  async (wallet_address: `0x${string}`) => _getWalletName(wallet_address),
  [],
  { revalidate: 604800 } // Cache for 1 week
)

/* Returns an ENS name if available, and if not, the wallet address.
 */
async function _getWalletName(
  walletAddress: `0x${string}`
): Promise<WalletNameAndType> {
  const ensName = await publicClient.getEnsName({
    address: walletAddress,
  })

  return ensName
    ? { name: ensName, type: "ENS" }
    : { name: walletAddress, type: "WALLET_ADDRESS" }
}
